import React, { useEffect } from "react";
import TopHeader from "../components/TopHeader";
import Navbar from "../blocs/Navbar";
import SearchForm from "../blocs/SearchForm";
import CategoryGrid from "../blocs/CategoryGrid";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlocsActifs } from "../store/slices/blocsReducer";
import { Helmet } from 'react-helmet-async';
import ServiceDispo from "../blocs/ServiceDispo";
import TestimonialBloc from "../blocs/TestimonialBloc";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Professionnel from "../blocs/Professionnel";
import Faqs from "../blocs/Faqs";
import Articles from "../blocs/Articles";
import Villes from "../blocs/Villes";
import BlocCcms from "../blocs/BlocCcms";
import { getRecentlyVisited } from "../store/slices/etablissementSlice";
import BlocEtablissement from "./etablissements/blocsEtablissement";

const Home = () => {
    const { isAuthenticated } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const { services, articles, faqs, professionnels, testimonials, villes, ccms, status, error } = useSelector((state) => state.blocs);
    const { recentlyVisited, recentlyVisitedStatus } = useSelector((state) => state.etablissements);
    // console.log("recentlyVisited:", recentlyVisited)
    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchBlocsActifs());
            // console.log('fetchedd',isAuthenticated)
            if(isAuthenticated){
               
              dispatch(getRecentlyVisited());  
            }
            
        }
    }, [dispatch, status]);

    return (
        <>
            <Helmet>
              
                {/* <meta name="description" content="Bienvenue sur la page d'accueil de notre site." />
                <meta name="keywords" content="accueil, React, SEO, site web" />
                <meta property="og:title" content="Page d'accueil -Marketplace de services" />
                <meta property="og:description" content="Découvrez notre site web et ses fonctionnalités." />
                <meta property="og:image" content="URL_de_l_image" />
                <meta property="og:url" content="https://www.monsite.com" /> */}
            </Helmet>
             <TopHeader btn={true}/>
             
            {status === 'loading' ? (
                <Skeleton height={50} width="100%" />
            ) : (
                <Navbar />
            )}   
         
            
            <SearchForm status={status} />
            <div className='container space-bloc'>
                {isAuthenticated ?
                    <BlocEtablissement
                        title={"Récemment consulté"}
                        status={recentlyVisitedStatus}
                        etablissements={recentlyVisited || []}
                        showCount={4}
                    />
                    : ''}
            </div>
            <CategoryGrid />
            <ServiceDispo services={services} status={status} />
            <BlocCcms ccms={ccms} status={status} />
            <TestimonialBloc testimonials={testimonials} status={status} title={testimonials.title}/>
            <Professionnel professionnels={professionnels} status={status} />
            <Faqs faqs={faqs} status={status} />
            <Articles articles={articles} status={status} />
            <Villes villes={villes} status={status} />
            <Footer />
        </>
    );
};
export default Home;
